import React from "react";
import {PeerActivityType} from "../../redux/Content/PeerActivity/types";
import PeerActivityLine from "../../blocks/Content/PeerActivity/PeerActivityLine";
import {MainIcon} from "../../redux/Main/icon";

import '../../i18/config';
import {useTranslation} from "react-i18next";

const TableActivitiesColumns = () => {

    const { t, i18n } = useTranslation();

    const FormatValue = (value:number) =>
        new Intl.NumberFormat('en-US', {
            style: 'decimal',
            notation: 'compact'
        }).format(value);

    const caseViewsSort = (rowA:PeerActivityType, rowB:PeerActivityType) => {

        const a = (rowA.stat && rowA.stat.views) || 0;
        const b = (rowB.stat && rowB.stat.views) || 0;

        if (a > b) {
            return 1;
        }

        if (b > a) {
            return -1;
        }

        return 0;
    };

    const caseLikesSort = (rowA:PeerActivityType, rowB:PeerActivityType) => {

        const a = (rowA.stat && rowA.stat.likes) || 0;
        const b = (rowB.stat && rowB.stat.likes) || 0;

        if (a > b) {
            return 1;
        }

        if (b > a) {
            return -1;
        }

        return 0;
    };

    const caseCommentsSort = (rowA:PeerActivityType, rowB:PeerActivityType) => {

        const a = (rowA.stat && rowA.stat.comments) || 0;
        const b = (rowB.stat && rowB.stat.comments) || 0;

        if (a > b) {
            return 1;
        }

        if (b > a) {
            return -1;
        }

        return 0;
    };

    const caseRepostsSort = (rowA:PeerActivityType, rowB:PeerActivityType) => {

        const a = (rowA.stat && rowA.stat.reposts) || 0;
        const b = (rowB.stat && rowB.stat.reposts) || 0;

        if (a > b) {
            return 1;
        }

        if (b > a) {
            return -1;
        }

        return 0;
    };

    return [
        {
            name: <span className='font-weight-bold fs-14'>{t('peerActivity:activity')}</span>,
            sortable: false,
            wrap: true,
            selector: (row:PeerActivityType) => {
                return (
                    <div className="pt-1">
                    <PeerActivityLine item={row}/>
                    </div>
                );
            },
        },
        {
            id: 'views',
            minWidth: '50px',
            maxWidth: '70px',
            name: <span className='text-muted fs-14' title={t('stat:views')}><i className={MainIcon.VIEWS}/></span>,
            sortable: true,
            wrap: true,
            selector: (row:PeerActivityType) => {
                return (
                    row.stat && row.stat.views && FormatValue(row.stat.views)
                );
            },
            sortFunction: caseViewsSort
        },
        {
            id: 'likes',
            minWidth: '50px',
            maxWidth: '70px',
            name: <span className='text-muted fs-14' title={t('stat:likes')}><i className={MainIcon.LIKES}/></span>,
            sortable: true,
            wrap: true,
            selector: (row:PeerActivityType) => {
                return (
                    row.stat && row.stat.likes && FormatValue(row.stat.likes)
                );
            },
            sortFunction: caseLikesSort
        },
        {
            id: 'comments',
            minWidth: '50px',
            maxWidth: '70px',
            name: <span className='text-muted fs-14' title={t('stat:comments')}><i className={MainIcon.COMMENTS}/></span>,
            sortable: true,
            wrap: true,
            selector: (row:PeerActivityType) => {
                return (
                    row.stat && row.stat.comments && FormatValue(row.stat.comments)
                );
            },
            sortFunction: caseCommentsSort
        },
        {
            id: 'reposts',
            minWidth: '50px',
            maxWidth: '70px',
            name: <span className='text-muted fs-14' title={t('stat:reposts')}><i className={MainIcon.REPOSTS}/></span>,
            sortable: true,
            wrap: true,
            selector: (row:PeerActivityType) => {
                return (
                    row.stat && row.stat.reposts && FormatValue(row.stat.reposts)
                );
            },
            sortFunction: caseRepostsSort
        },
    ];

}

export default TableActivitiesColumns;